<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="container-fluid mt-3" *ngIf="!loading">

  <!-- Header -->
  <div class="d-flex align-items-center mb-3">
    <button pButton pRipple class="p-button-text p-button-secondary" icon="pi pi-arrow-left" label="Back" (click)="goBack()" style="margin-right: 12px;"></button>
    <h2 style="margin: 0;">Activity Wish List
      <p-tag [value]="wishlist.status" [severity]="getStatusSeverity(wishlist.status)" style="margin-left: 10px;"></p-tag>
    </h2>
  </div>

  <div class="row">

    <!-- Left panel: Guest / Reservation info (read-only) -->
    <div class="col-md-5">
      <p-card header="Guest & Reservation Info">
        <div class="p-fluid">

          <div class="field mb-3">
            <label class="fw-bold">Guest Name</label>
            <p>{{wishlist.guestFirstName}} {{wishlist.guestLastName}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Email</label>
            <p>{{wishlist.guestEmail || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Phone</label>
            <p>{{wishlist.guestPhone || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Reservation ID</label>
            <p>{{wishlist.reservationId || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Property</label>
            <p>{{wishlist.propertyName || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Check-in</label>
            <p>{{wishlist.checkIn | date:'MM/dd/yyyy' || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Check-out</label>
            <p>{{wishlist.checkOut | date:'MM/dd/yyyy' || '—'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Island</label>
            <p>{{wishlist.addressIsland || '—'}}</p>
          </div>

          <div class="field mb-3" *ngIf="wishlist.guestNotes">
            <label class="fw-bold">Guest Notes</label>
            <p style="white-space: pre-wrap;">{{wishlist.guestNotes}}</p>
          </div>

          <div class="field mb-3" *ngIf="wishlist.sentDate">
            <label class="fw-bold">Suggestion Sent</label>
            <p>{{wishlist.sentDate | date:'MM/dd/yyyy h:mm a'}}</p>
          </div>

          <div class="field mb-3" *ngIf="wishlist.viewedDate">
            <label class="fw-bold">Viewed by Guest</label>
            <p>{{wishlist.viewedDate | date:'MM/dd/yyyy h:mm a'}}</p>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Created</label>
            <p>{{wishlist.createDate | date:'MM/dd/yyyy h:mm a'}}</p>
          </div>

        </div>
      </p-card>
    </div>

    <!-- Right panel: Editable fields + wish list items -->
    <div class="col-md-7">

      <!-- Wish list items table -->
      <p-card header="Wish List Items" class="mb-3" styleClass="mb-3">
        <p-table [value]="parsedItems" styleClass="p-datatable-sm p-datatable-striped" *ngIf="parsedItems.length > 0">
          <ng-template pTemplate="header">
            <tr>
              <th>Activity</th>
              <th>Requested Date</th>
              <th>Party Size</th>
              <th>Notes</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{item.activityName || item.name || '—'}}</td>
              <td>{{item.requestedDate || item.date || '—'}}</td>
              <td>{{item.partySize || '—'}}</td>
              <td>{{item.notes || '—'}}</td>
            </tr>
          </ng-template>
        </p-table>
        <p *ngIf="parsedItems.length === 0" class="text-muted">No items.</p>
      </p-card>

      <!-- Staff editable fields -->
      <p-card header="Staff Response">
        <div class="p-fluid">

          <div class="field mb-3">
            <label class="fw-bold">Status</label>
            <p-dropdown [options]="statuses" optionLabel="name" optionValue="value"
              [(ngModel)]="wishlist.status" placeholder="Select status" styleClass="w-100"></p-dropdown>
          </div>

          <div class="field mb-3">
            <label class="fw-bold">Staff Notes</label>
            <textarea pInputTextarea rows="6" style="width:100%;"
              [(ngModel)]="wishlist.staffNotes" placeholder="Internal notes or suggestion details..."></textarea>
          </div>

        </div>

        <!-- Action buttons -->
        <div class="d-flex gap-2 mt-3">
          <button pButton pRipple label="Save" icon="pi pi-save" class="p-button-primary"
            (click)="onSave()" [disabled]="saving">
          </button>

          <button pButton pRipple label="Send to Guest" icon="pi pi-send" class="p-button-success"
            *ngIf="canSendToGuest()"
            (click)="onSendToGuest()" [disabled]="sending">
          </button>

          <button pButton pRipple label="Delete" icon="pi pi-trash" class="p-button-danger"
            (click)="onDelete()" [disabled]="deleting" style="margin-left: auto;">
          </button>
        </div>

      </p-card>

    </div>
  </div>
</div>

<div class="container mt-5 text-center" *ngIf="loading">
  <p-progressSpinner></p-progressSpinner>
</div>
